module.exports = __webpack_public_path__ + "img/利润表.a43d7409.png";